const { WhatsAppService } = require('./WhatsAppService');

export { WhatsAppService };
